import * as React from "react";
import { NumberFormatter } from "../core/numberFormatter";
import { MetricKey } from "../model/keyedMetrics";

export enum MetricsChartBarState {
    Hidden,
    Legend,
    Visible
}

interface MetricsChartBarProps {
    metricKey: MetricKey;
    value: number;
    total: number;
    state: MetricsChartBarState;
    onClick: () => void;
}

const LegendBarHeight = 48;
const MinBarHeight = 120;
const MaxBarHeight = 240;

export class MetricsChartBar extends React.Component<MetricsChartBarProps, {}> {
    render(): JSX.Element {
        return <div className="metrics-bar vbox" style={{ height: this.heightOfBar, top: this.yOffsetOfBar, background: this.props.metricKey.color }}  onClick={this.props.onClick}>
            <div className="metrics-bar-icon expand hcenter">
                <img src={this.props.metricKey.iconPath} height={28} width="auto"/>
            </div>
            <div className="metrics-bar-value hcenter">{this.valueToDisplay}</div>
            <div className="metrics-bar-percent hcenter">{this.percentToDisplay}</div>
        </div>;
    }

    private get heightOfBar(): number {
        switch (this.props.state) {
            case MetricsChartBarState.Hidden:
            case MetricsChartBarState.Legend:
                return MinBarHeight;
            case MetricsChartBarState.Visible:
                let percent = (this.props.total > 0) ? this.props.value / this.props.total : 0;
                return MinBarHeight + percent * (MaxBarHeight - MinBarHeight);
        }
    }

    private get yOffsetOfBar(): number {
        switch (this.props.state) {
            case MetricsChartBarState.Hidden:
                return this.heightOfBar;
            case MetricsChartBarState.Legend:
                return this.heightOfBar - LegendBarHeight;
            case MetricsChartBarState.Visible:
                return 0;
        }
    }

    private get valueToDisplay(): string {
        return NumberFormatter.getShortValueToDisplay(this.props.value);
    }

    private get percentToDisplay(): string {
        if (this.props.total > 0) {
            return `${((this.props.value * 100) / this.props.total).toFixed()}%`;
        } else {
            return "0%";
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/metricsChartBar.tsx